import { useUser } from "../../context/user-context";
import { matchesCurrency, matchesNetwork } from "../../utils/asset-config";

const useGetDepositAddy = (coin: string, network: string) => {
  const { userDetails } = useUser();

  const getDepositWalletAddress = () => {
    const walletAddresses = userDetails?.user?.wallets;

    if (!walletAddresses || !coin || !network) return null;

    const match = walletAddresses.find(
      (w: { currency: string; network: string; walletType: string; address: string }) =>
        w.walletType === "DEPOSIT" &&
        matchesCurrency(w.currency, coin) &&
        matchesNetwork(w.network, network),
    );

    return match?.address || null;
  };

  return getDepositWalletAddress();
};

export default useGetDepositAddy;
